import script from "./AddUserDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddUserDialog.vue?vue&type=script&lang=ts&setup=true"

import "./AddUserDialog.vue?vue&type=style&index=0&id=e222a300&lang=sass&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/gyEBPJq1/0/curvesdev/skolkovo-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e222a300"]])

export default __exports__